import { CreateAccount } from '../pages/CreateAccount'
import { Login } from '../pages/Login'
import { Routes, Route } from 'react-router-dom'
import { EmailValidation } from '../pages/EmailValidation'
import { ChoosePlan } from '../pages/ChoosePlan'
import { PaymentData } from '../pages/PaymentData'
import { PaymentSucess } from '../pages/PaymentSucess'
import { ParentInformation } from '../pages/ParentInformation'
import { PasswordReset } from '../pages/PasswordReset'
import { PasswordResetEmailSent } from '../pages/PasswordResetEmailSent'
import { PasswordSetNew } from '../pages/PasswordSetNew'
import { PasswordResetSuccess } from '../pages/PasswordResetSuccess'
import { TermsOfUse } from '../pages/TermsOfUse'
import { CreateUserChild } from '../pages/CreateUserChild'

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/create-account" element={<CreateAccount />} />
      <Route path="/email-validation" element={<EmailValidation />} />
      <Route path="/choose-plan" element={<ChoosePlan />} />
      <Route path="/payment-data" element={<PaymentData />} />
      <Route path="/payment-sucess" element={<PaymentSucess />} />
      <Route path="/parent-information" element={<ParentInformation />} />
      <Route path="/password-reset" element={<PasswordReset />} />
      <Route path="/password-reset-email-sent" element={<PasswordResetEmailSent />} />
      <Route path="/pr" element={<PasswordSetNew />} />
      <Route path="/password-reset-success" element={<PasswordResetSuccess />} />
      <Route path="/create-user-child" element={<CreateUserChild />} />

      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="*" element={<Login />} />
    </Routes>
  )
}
